module.exports = __webpack_public_path__ + "atreg.jpg?8c61212408b685c6bcf5c2c17900cdc8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/atreg.jpg
// module id = 30
// module chunks = 0